module.exports = __webpack_public_path__ + "static/media/5-mobile.88de5fd1.jpg";